export default theme => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	titleContainer: {
		position: 'static',
		'@media screen and (min-width: 992px)': {
			position: 'fixed',
		},
		width: '100%',
		fontSize: '18px',
		padding: '6px 10px',
		'@media screen and (min-width: 410px)': {
			padding: '6px 30px',
		},
		backgroundColor: theme.colors.primary,
		borderBottom: '2px solid #ebebeb',
	},
	title: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		maxWidth: '1400px',
		margin: '0 auto',
		color: '#fff',
		lineHeight: '36px',
	},
	bodyContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		margin: '0px 10px 0',
		'@media screen and (min-width: 410px)': {
			margin: '0px 30px 0',
		},
		'@media screen and (min-width: 992px)': {
			margin: '50px 30px 0',
		},
	},
	body: {
		width: '100%',
		maxWidth: '1200px',
	},
	goalBox: {
		border: '1px solid #ebebeb',
		borderRadius: '5px',
		backgroundColor: '#fff',
		margin: '5px 0 10px',
		padding: '6px',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		lineHeight: '1.6',
		flexWrap: 'wrap',
		'@media screen and (min-width: 640px)': {
			flexWrap: 'nowrap',
		},
	},
	goalPicture: {
		marginBottom: '6px',
		'@media screen and (min-width: 640px)': {
			margin: '1px 20px 1px 1px',
		},
	},
	goalImg: {
		width: '100%',
		maxWidth: '300px',
		borderRadius: '3px',
	},
	goalContent: {
		flexGrow: '1',
		'& p, & $p': {
			padding: '1px 0',
		},
	},
	goalTitle: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		'& a': {
			fontSize: '18px',
			fontWeight: theme.fontWeight.bold,
			display: 'inline',
		},
	},
	goalTitleFine: {
		fontSize: '0.8em',
		marginLeft: '18px',
		verticalAlign: 'text-top',
		lineHeight: '14px',
	},
	goalDegrees: {
		display: 'flex',
		flexDirection: 'row',
		margin: '2px 0',
		'& > div': {
			marginRight: '50px',
		},
	},
	studyMode: {
		color: '#70c067',
		border: '1px solid #70c067',
		borderRadius: '2px',
		padding: '0 5px',
	},
	goalFooter: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'flex-end',
		fontSize: '0.8em',
	},
	goalActions: {
		display: 'flex',
		flexDirection: 'row',
		marginLeft: '-10px',
		'& a': {
			display: 'block',
			textAlign: 'center',
			width: '80px',
		},
	},
	blue: {
		color: theme.colors.primary,
	},
	error: {
		color: '#bf1d1d',
		'& > a': {
			display: 'inline'
		},
	},
	section: {
		display: 'flex',
		flexDirection: 'column-reverse',
		margin: '10px 0 20px',
		'@media screen and (min-width: 410px)': {
			margin: '30px 0',
		},
		'@media screen and (min-width: 640px)': {
			margin: '40px 0',
			flexDirection: 'row',
		},
		'& > div': {
			'& > p': {
				fontSize: '16px',
				textAlign: 'justify',
				margin: '20px 0',
			},
			'& > h2': {
				fontSize: '32px',
				fontWeight: theme.fontWeight.light,
				lineHeight: '40px',
				textAlign: 'left',
			},
		},
	},
	sectionText: {
		'@media screen and (min-width: 640px)': {
			padding: '0px 0px 0px 45px',
		},
		flexGrow: '1',
		flexBasis: '0',
		'& $createButton': {
			margin: '30px auto 0',
			'@media screen and (min-width: 640px)': {
				display: 'none',
			},
			'@media screen and (min-width: 768px)': {
				margin: '40px auto 0',
				display: 'block',
			},
		}
	},
	sectionFineText: {
		color: '#888',
		fontSize: '12px',
		lineHeight: '13px',
		marginBottom: '25px',
	},
	sectionPicture: {
		flexGrow: '1',
		flexBasis: '0',
		marginTop: '20px',
		'@media screen and (min-width: 410px)': {
			marginTop: '40px',
		},
		'@media screen and (min-width: 640px)': {
			marginTop: '0px',
			padding: '0px 45px 0px 0px',
		},
		'& img': {
			width: '100%',
		}
	},
	createButton: {
		display: 'block',
		maxWidth: '350px',
		whiteSpace: 'normal',
		'& .ion-plus': {
			marginRight: '5px',
		},
	},
	createButtonBottom: {
		margin: '0 auto 40px',
		display: 'none',
		'@media screen and (min-width: 640px)': {
			display: 'block',
		},
		'@media screen and (min-width: 768px)': {
			display: 'none',
		},
	},
	whenLarge: {
		display: 'none',
		'@media screen and (min-width: 410px)': {
			display: 'inline',
		},
	},
	createButtonRound: {
		width: '50px',
		height: '50px',
		borderRadius: '100%',
		'& span.ion-plus': {
			fontSize: '27px',
		}
	},
	list: {
		fontSize: '16px',
		margin: '1em 0 0 2em',
		'& li:nth-child(1)::before': {
			content: '"1"',
		},
		'& li:nth-child(2)::before': {
			content: '"2"',
		},
		'& li:nth-child(3)::before': {
			content: '"3"',
		},
		'& li::before': {
			backgroundColor: '#5aa874',
			color: '#fff',
			fontWeight: theme.fontWeight.bold,
			display: 'inline-block',
			width: '22px',
			height: '22px',
			marginRight: '10px',
			marginLeft: '-32px',
			marginTop: '15px',
			borderRadius: '100%',
			textAlign: 'center',
		},
		'& li': {
			// lineHeight: 'em',
		},
	},
	deleteLink: {
		cursor: 'pointer',
		marginRight: '-15px',
	},
	p: {}
});
